var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.960391 11.0366C0.651111 10.7273 0.651111 10.2258 0.960391 9.91656L9.92039 0.956576C10.2297 0.647297 10.7311 0.647297 11.0404 0.956576C11.3497 1.26585 11.3497 1.7673 11.0404 2.07657L2.08039 11.0366C1.77111 11.3458 1.26967 11.3458 0.960391 11.0366Z",
    fill: "#20313F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.960391 0.955626C1.26967 0.646347 1.77111 0.646347 2.08039 0.955626L11.0404 9.91561C11.3497 10.2249 11.3497 10.7263 11.0404 11.0356C10.7311 11.3449 10.2297 11.3449 9.92039 11.0356L0.960391 2.07562C0.651111 1.76635 0.651111 1.2649 0.960391 0.955626Z",
    fill: "#20313F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6bbfa55113e178545db150797faf605f.svg";
export { ForwardRef as ReactComponent };